import { useMutation } from "@tanstack/react-query";
import fetchData from "../fetcher";

export const useLogOutAll = () => {

    const { mutate: logOutAll, mutateAsync: logOutAllAsync, isPending: isLogOutAllPending, isError } = useMutation({
        mutationKey: ["log-out-all"],
        mutationFn: async () => {
            return fetchData("/iam/v4/auth/logout-all", {
                method: "POST",
                body: {
                    useBackchannel: true
                }
            });
        },
    })

    return {
        logOutAll,
        logOutAllAsync,
        isLogOutAllPending,
        isError
    }
}